export function adminExerciseUrl(exerciseName: string) {
  return `/admin?tab=exercises&exerciseSearch=${encodeURIComponent(exerciseName)}`;
}

export function openAdminExerciseSearch(exerciseName: string) {
  window.open(adminExerciseUrl(exerciseName), "_blank", "noopener,noreferrer");
}
